import { useQuery } from "@tanstack/react-query";
import { getSettings } from "../../api/apiSettings";

export const useGetSettings = ({ reveal = false } = {}) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["settings", { reveal }],
        queryFn: () => getSettings(reveal ? { reveal: true } : undefined),
        retry: false,
    });

    return {
        settings: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
